jQuery(document).ready(function ($) {
  if (typeof temoignage_ajax === 'undefined') {
    console.error('temoignage_ajax is not defined. Script may not be properly localized.');
    return;
  }

  let paged = 2; // Page 1 is server-rendered

  function getFreshNonce() {
    return new Promise(function (resolve, reject) {
      $.ajax({
        type: "POST",
        url: temoignage_ajax.ajax_url,
        data: {
          action: "get_fresh_nonce",
          nonce_action: "load_more_temoignages"
        },
        success: function (response) {
          if (response && response.success && response.data && response.data.nonce) {
            resolve(response.data.nonce);
          } else {
            reject('Invalid fresh-nonce response');
          }
        },
        error: function () {
          reject('Network error fetching fresh nonce');
        }
      });
    });
  }

  $(".load-more-temoignages").on("click", function (e) {
    e.preventDefault();
    var button = $(this);
    button.text("Chargement...");

    function makeAjaxRequest(nonce, isRetry) {
      isRetry = !!isRetry;
      return $.ajax({
        type: "POST",
        url: temoignage_ajax.ajax_url,
        data: {
          action: "load_more_temoignages",
          nonce: nonce,
          paged: paged,
        },
        success: function (response) {
          // wp_send_json_error returns HTTP 200 with success:false, so we
          // have to detect application-level failures here, not in error().
          if (!response || !response.success) {
            var message = (response && response.data && response.data.message) || '';
            if (!isRetry && /nonce/i.test(message)) {
              // Stale nonce (very common when the page came from a cache).
              // Get a fresh one and retry once.
              getFreshNonce().then(function (fresh) {
                return makeAjaxRequest(fresh, true);
              }).catch(function (err) {
                console.error('temoignage load-more: nonce retry failed:', err);
                button.text("Réessayer");
              });
              return;
            }
            console.error('temoignage load-more: server returned error:', message || response);
            button.text("Réessayer");
            return;
          }

          var html = (response.data && response.data.html) || '';
          if (html.trim() !== '') {
            $(".section-content-rating_grid").append(html);
            paged++;
            button.text("Voir plus");
          }

          if ((response.data && response.data.hide_button) || html.trim() === '') {
            button.fadeOut();
          }
        },
        error: function (xhr) {
          // HTTP-level errors are rare here, but handle them anyway.
          var responseText = xhr.responseText || '';
          if (!isRetry && (xhr.status === 403 || /nonce/i.test(responseText))) {
            getFreshNonce().then(function (fresh) {
              return makeAjaxRequest(fresh, true);
            }).catch(function (err) {
              console.error('temoignage load-more: nonce retry failed:', err);
              button.text("Réessayer");
            });
            return;
          }
          console.error('temoignage load-more: HTTP error', xhr.status, responseText);
          button.text("Réessayer");
        }
      });
    }

    makeAjaxRequest(temoignage_ajax.nonce);
  });
});
